import api from '@/libs/api'

const initState = {
  adminMetadata: {
    event: [],
    user: []
  },
  metaTagsList: [],
  virtualDrawerData: {
    virtualName: '',
    cname: '',
    tags: [],
    visible: 0,
    remark: '',
    events: [
      {
        eventName: '',
        filter: {
          relation: {
            value: 'and',
            name: '且'
          },
          conditions: []
        }
      }
    ]
  }
};

const metadata = {
  state: initState,
  mutations: {
    RESET_metadata(state) {
      state = Object.assign(state, initState);
    },
    SET_ADMIN_METADATA(state, data) {
      state.adminMetadata = data;
    },
    SET_META_TAGS(state, list) {
      state.metaTagsList = list;
    },
    SET_VIRTUAL_DRAWER_DATA(state, data) {
      state.virtualDrawerData = data;
    }
  },
  actions: {
    setEventsTags({ commit }, projectId) {
      api.getTags(projectId)    //获取tags
        .then(res => {
          if (res.data.status === 1) {
            const list = res.data.fields.list.map(item => Object.assign({}, item, { checked: false }));
            commit('SET_META_TAGS', list);
          }
        })
    }
  }
};

export default metadata;



// WEBPACK FOOTER //
// ./src/store/modules/metadata.js